// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__hCADa","warning":"badge_warning__J657J","success":"badge_success__t1Lsx","fail":"badge_fail__Adqp6","info":"badge_info__P2mf+"};